/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_On_Privacy_DescInputs */

const en_wc_on_privacy_desc = /** @type {(inputs: Wc_On_Privacy_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The web build has no server-side code. Our server only delivers the app files; documents you open are processed inside your browser and saved back to your device through normal downloads. Preferences live in your browser's local storage.`)
};

/**
* | output |
* | --- |
* | "The web build has no server-side code. Our server only delivers the app files; documents you open are processed inside your browser and saved back to your de..." |
*
* @param {Wc_On_Privacy_DescInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_on_privacy_desc = /** @type {((inputs?: Wc_On_Privacy_DescInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_On_Privacy_DescInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_on_privacy_desc(inputs)
});
export { wc_on_privacy_desc as "wc.on.privacy_desc" }